import {
  React,
  useState,
  useContext,
  useEffect,
  useRef,
  createContext,
} from "react";
import axios from "axios";

import safetyIcon from "../../../Images/bureauImages/safetyIcon.png";
import backArrow from "../../../Images/bureauImages/backArrow.png";
import pdfIcon from "../../../Images/bureauImages/pdfIcon.png";
import pdfIcon2 from "../../../Images/bureauImages/pdfIcon2.png";
import ptrem1 from "../../../Images/bureauImages/ptrem1.png";
import ptrem2 from "../../../Images/bureauImages/ptrem2.png";
import ptrem3 from "../../../Images/bureauImages/ptrem3.png";
import ptrem4 from "../../../Images/bureauImages/ptrem4.png";
import { BureauContext } from "../../Pages/HelloTradePage";
import { gatrack, getCurrentIST } from "../../../utils";
import { writeLogs } from "../../../utils";

import { banks } from "../../../utils";

export const StateContext = createContext();

function BankingComponent() {
  const { displayPage, setDisplayPage, otpScreen, userInfo } =
    useContext(BureauContext);

  const today = new Date();

  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(today.getFullYear() - 1);

  const formatDate = (date) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options); // Format: DD MMM YYYY
  };

  const goBack = () => {
    setDisplayPage(1);
  };

  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const dropdownRef = useRef(null);
  const [bankErr, setBankErr] = useState("");
  const [password, setPassword] = useState("");
  const [isContClick, setIsContClick] = useState(false);
  const [bankPDfList, setBankPdfList] = useState([]);
  const [passErr, setPassErr] = useState("");
  const [fileErr, setFileErr] = useState("");
  const [noOfBankErr, setNoOfBankErr] = useState("");
  const fileInputRef = useRef(null);

  const stateValues = {
    isOpen,
    setIsOpen,
    searchTerm,
    setSearchTerm,
    selectedBank,
    setSelectedBank,
    dropdownRef,
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const updateBankPdfList = (selectedBank, files, password) => {
    // console.log("Selected Bank:", selectedBank);
    // console.log("Files:", files);
    // console.log("Password:", password);

    setBankPdfList((prevList) => {
      const existingIndex = prevList.findIndex(
        (item) => item.selectedBank === selectedBank
      );

      if (existingIndex !== -1) {
        const updatedList = [...prevList];
        updatedList[existingIndex] = {
          ...updatedList[existingIndex],
          files: [...files],
          password,
        };
        return updatedList;
      } else {
        return [...prevList, { selectedBank, files: [...files], password }];
      }
    });
  };

  const consoleOP = (var1) => {
    console.log(var1);
  };

  const handlePDFBoxClick = (bank) => {
    // console.log(bank)
    setIsContClick(false);
    setFiles(bank.files)
    setSelectedBank(bank.selectedBank)
  };

  const handleFileUpload = (event) => {
    //triggerFileInput();
    let TempConsoleFiles = event.target.files;
    if (TempConsoleFiles.length > 0) {
      console.log("Uploaded Documents/Files:");
      Array.from(TempConsoleFiles).forEach((fileDetails) =>
        console.log(fileDetails.name)
      );
    }

    if (selectedBank == "") {
      setBankErr("Please select your bank first.");
      return;
    }

    setBankErr("");

    const newFiles = Array.from(event.target.files);
    setFiles((prevFiles) => {
      const totalAllowed = 12;
      const availableSlots = totalAllowed - prevFiles.length;

      const filesToUpload =
        availableSlots > 0 ? newFiles.slice(0, availableSlots) : [];

      return [...prevFiles, ...filesToUpload];
    });
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const newFiles = Array.from(event.dataTransfer.files);

    const pdfFiles = newFiles.filter((file) => file.type === "application/pdf");

    setFiles((prevFiles) => {
      const totalAllowed = 12;
      const availableSlots = totalAllowed - prevFiles.length;

      const filesToUpload =
        availableSlots > 0 ? pdfFiles.slice(0, availableSlots) : [];

      return [...prevFiles, ...filesToUpload];
    });

    setIsDragging(false);
  };

  const handleFileDelete = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleContClick = async () => {
    //console.log("In on click");
    //console.log(files);

    let time = getCurrentIST();
    writeLogs(
      userInfo.glid,
      `bank: ${selectedBank}, files: ${files.length}`,
      "NA",
      "CLICK",
      "Continue CTA",
      "200",
      "NA",
      time,
      time,
      0
    );

    if (files.length == 0) {
      setFileErr("Please select the files.");
      return;
    }
    setFileErr("");
    if (isChecked && password == "") {
      setPassErr("Please enter password.");
      return;
    }
    updateBankPdfList(selectedBank, files, password);

    setPassErr("");

    if (!isContClick) {
      setIsContClick(true);
    }
    if (files.length > 0) {
      // setDisplayPage(4);
      // const resp = await storeUploadedFiles();
      // if(resp){
      //     setDisplayPage(4);
      // }
    }
  };

  const handleNextClick = async () => {
    setNoOfBankErr("");
    const host = window.location.hostname;
    const url =
      host === "www.hellotrade.com"
        ? "https://loans.indiamart.com/api/v1/bulkUpload"
        : "https://dev-loans.indiamart.com/api/v1/bulkUpload";

    const formData = new FormData();

    // Dynamically append each bank's data
    bankPDfList.forEach((bank, index) => {
      formData.append(`banks[${index}][selectedBank]`, bank.selectedBank);
      formData.append(`banks[${index}][password]`, bank.password);

      // Check if there are files and append them as an array
      if (bank.files && bank.files.length > 0) {
        // Append all files in the same 'banks[0][files]' array
        bank.files.forEach((file) => {
          formData.append(`banks[${index}][files]`, file); // No file index, just 'files'
        });
      }
    });

    // Append GLID
    formData.append("glid", userInfo.glid);
    formData.append("ak", userInfo.ak);

    // Log FormData for debugging
    formData.forEach((value, key) => {
      //console.log(key, value); // Log key-value pairs from FormData
    });

    let inTime = getCurrentIST();

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-api-key": "bwBaf/a627Gv", // Add your actual API key here
        },
        timeout: 5000,
      });

      //console.log("Data received: ", response);
      let outTime = getCurrentIST();
      if (response.data && response.data.CODE == "200") {
        gatrack(
          "HT Journey",
          "Banking Uploaded",
          "Banking Page",
          userInfo.glid
        );
        writeLogs(
          userInfo.glid,
          "PDF files",
          "SUCCESS",
          "CLICK",
          "Next CTA",
          "200",
          "NA",
          inTime,
          outTime,
          0
        );

        setDisplayPage(5);
        return true;
      }

      let issue = "Bulk Upload API issue.";
      if (response.data) {
        issue = JSON.stringify(response.data);
      }

      gatrack(
        "HT Journey",
        "Error in uploading banking",
        "Banking Page",
        userInfo.glid
      );
      writeLogs(
        userInfo.glid,
        "PDF files",
        "FAILURE",
        "CLICK",
        "Next CTA",
        "400",
        issue,
        inTime,
        outTime,
        0
      );

      return false;
    } catch (error) {
      gatrack(
        "HT Journey",
        "Error in uploading banking",
        "Banking Page",
        userInfo.glid
      );
      writeLogs(
        userInfo.glid,
        "PDF files",
        "FAILURE",
        "CLICK",
        "Next CTA",
        "500",
        "In Catch block",
        inTime,
        "outTime",
        0
      );
      console.error("Error uploading documents:", error);
      return false;
    }
  };

  const handleAnotherBankClick = () => {
    let time = getCurrentIST();
    writeLogs(
      userInfo.glid,
      `List length: ${bankPDfList.length}`,
      "NA",
      "CLICK",
      "Upload Another CTA",
      "200",
      "NA",
      time,
      time,
      0
    );

    if (bankPDfList.length == 3) {
      setNoOfBankErr("Only 3 banks can be selected.");
      return;
    }

    setNoOfBankErr("");

    if (isContClick) {
      setIsContClick(false);
      setPassword("");
      setSelectedBank("");
      setFiles([]);
      setSearchTerm("");
    }
  };

  const handleLabelInputClick = () => {
    if (selectedBank == "") {
      setBankErr("Please select your bank first.");
      return;
    }
    setBankErr("");
    console.log("IN log Click");
    triggerFileInput();
    let time = getCurrentIST();
    writeLogs(
      userInfo.glid,
      "NA",
      "NA",
      "CLICK",
      "Upload PDF",
      "200",
      "NA",
      time,
      time,
      0
    );
  };

  const triggerFileInput = () => {
    console.log("In trigger func");
    console.log(fileInputRef.current)
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      console.log("clicking trigger ref");
      fileInputRef.current.click();
    }
  };

  useEffect(() => {
    //console.log("Updated bankPDfList:", bankPDfList);
  }, [bankPDfList]);

  return (
    <StateContext.Provider value={stateValues}>
      <>
        <div id="pi-parent">
          <div className="pi bank-upload">
            <div className="pi-header">
              {/* <span id="back-arrow-parent" onClick={goBack}>
              <img src={backArrow} style={{ width: "16px" }} />
            </span> */}
              <span id="header-text">Upload Bank Statement</span>
            </div>

            <div className="progress-bar">
              <div className="progress-indicator"></div>
            </div>
            <div id="offer">
              <div>
                {" "}
                <span style={{ fontWeight: "600" }}>
                  <i
                    class="bi bi-filetype-pdf"
                    style={{ color: "red", marginRight: "8px" }}
                  ></i>
                  Upload Bank Statement from{" "}
                </span>
                <span>
                  {formatDate(oneYearAgo)} to {formatDate(today)}
                </span>
              </div>
            </div>

            {!isContClick && (
              <>
                <div>
                  {files.length === 0 ? (
                    <>
                      <div className="bankSelectionBox">
                        <div className="col-6 bankBoxes selectBank">
                          <div className="selectYourBank">Select your bank</div>
                          <BankDropdown />
                        </div>

                        <div className="col-6 inputSelect">
                          <div
                            className={`bankBoxes upload-box ${
                              isDragging ? "dragging" : ""
                            }`}
                            // style={{width:'70%'}}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                          >
                            <input
                              type="file"
                              accept="application/pdf"
                              multiple
                              onChange={handleFileUpload}
                              style={{ display: "none" }}
                              id="file-upload"
                              ref={fileInputRef}
                            />
                            <label
                              //   htmlFor="file-upload"
                              className="content-label"
                              onClick={handleLabelInputClick}
                            >
                              <div className="upload-icon">
                                <img src={pdfIcon} alt="PDF icon" />
                              </div>
                              <div className="upload-txt">
                                Upload PDF upto 50MB
                              </div>
                              <div className="upload-btn">Upload File</div>
                            </label>
                          </div>

                          {bankErr != "" && (
                            <div className="bankErr">{bankErr}</div>
                          )}
                        </div>
                      </div>
                      {/* <div className='multiple-docs'><i class="bi bi-stack"></i>You can upload multiple document.</div> */}
                    </>
                  ) : (
                    <div>
                      <div className="selectedBank col-6">{selectedBank}</div>
                      <div className="bankSelectionBoxFilesSelected">
                        <div className="col-12 col-md-6">
                          <div className="file-list">
                            <div className="file-list-header">
                              <span>Documents</span>
                              <span className="multiple-docs">
                                {files.length} uploaded
                              </span>
                            </div>
                            {files.map((file, index) => (
                              <div key={index} className="file-item">
                                <img
                                  src={pdfIcon2}
                                  alt="PDF icon"
                                  className="file-icon"
                                />
                                <div className="file-info">
                                  <span className="file-name">{file.name}</span>
                                  <span className="file-size">
                                    {(file.size / (1024 * 1024)).toFixed(2)} MB
                                  </span>
                                </div>
                                <div className="file-status">
                                  {/* <div className="d-flex justify-content-center align-items-center" >
                                                          <div className="spinner-border" role="status">
                                                          </div>
                                                      </div>   */}
                                  <i
                                    class="bi bi-trash-fill"
                                    onClick={() => handleFileDelete(index)}
                                    style={{ cursor: "pointer" }}
                                  ></i>
                                </div>
                              </div>
                            ))}

                            <div className="passwordCheckbox">
                              <label>
                                <input
                                  type="checkbox"
                                  checked={isChecked}
                                  onChange={handleCheckboxChange}
                                  style={{ marginRight: "8px" }}
                                  className="customCheckbox"
                                />
                                Above statement is password protected
                              </label>
                            </div>

                            {isChecked && (
                              <div className="passwordInputContainer">
                                <input
                                  type="password"
                                  placeholder="Enter password"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value.replace(/\s/g, ""))}
                                  className="passwordInput"
                                />
                              </div>
                            )}

                            {passErr != "" && (
                              <div
                                className="bankErr"
                                style={{ textAlign: "left" }}
                              >
                                {passErr}
                              </div>
                            )}
                          </div>

                          <div></div>
                        </div>

                        <div
                          className={`col-6 bankBoxes upload-box ${
                            isDragging ? "dragging" : ""
                          }`}
                          // style={{width:'40%'}}
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                        >
                          <input
                            type="file"
                            accept="application/pdf"
                            multiple
                            onChange={handleFileUpload}
                            style={{ display: "none" }}
                            id="file-upload"
                            ref={fileInputRef}
                          />
                          <label
                            // htmlFor="file-upload"
                            className="content-label"
                            onClick={handleLabelInputClick}
                          >
                            <div className="upload-icon">
                              <img src={pdfIcon} alt="PDF icon" />
                            </div>
                            <div className="upload-txt">
                              Upload PDF upto 50MB
                            </div>
                            <div className="upload-btn">Upload File</div>
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <PointsToRemember />

                <div className="contDiv">
                  <div
                    className="cont-btn"
                    style={
                      files.length > 0
                        ? { backgroundColor: "#00B2A4", color: "#FFFFFF" }
                        : {}
                    }
                    onClick={handleContClick}
                  >
                    Continue
                  </div>
                </div>

                {fileErr != "" && (
                  <div className="bankErr" style={{ paddingTop: "8px" }}>
                    {fileErr}
                  </div>
                )}
              </>
            )}
            {isContClick && (
              <>
                <div id="allBankingList" className="allBankingList">
                  <div className="selectedBanksBox">
                    {consoleOP(bankPDfList)}
                    {bankPDfList.map((bank, index) => (
                      <div
                        key={index}
                        className="bankPDFBox"
                        onClick={() => handlePDFBoxClick(bank)}
                      >
                        <div style={{ display: "flex", padding: "10px 0px" }}>
                          <div className="bankNameHeader">
                            {bank.selectedBank}
                          </div>
                          {/* <input type="checkbox" style={{ marginLeft: "auto" }} /> */}
                        </div>

                        <hr style={{ margin: "0px" }} />

                        <div className="pdfName">
                        <i class="bi bi-check-circle-fill feature-tick"></i>
                        <span className="file-upload-text">{bank.files.length} {bank.files.length === 1 ? "file" : "files"} uploaded</span>

                        <i class="bi bi-chevron-right" style={{color:'#898989',marginLeft:'auto'}}></i>
                          {/* {bank.files.map((file, fileIndex) => (
                            <div key={fileIndex} className="pdfNameList">
                              <i
                                class="bi bi-filetype-pdf"
                                style={{ color: "red", marginRight: "8px" }}
                              ></i>
                              {file.name}
                            </div>
                          ))} */}
                        </div>

                        <div className="upload-more">
                          <i class="bi bi-upload" style={{color:'#00B2A4',margin:'0px 8px'}}></i>
                          <span className="upload-more-text">Upload More</span>
                        </div>

                      </div>
                    ))}
                  </div>

                  <div
                    className="col-4 anotherBank"
                    onClick={handleAnotherBankClick}
                  >
                    <div className="plusSign">
                      <i
                        class="bi bi-plus"
                        style={{ color: "#FFF", display: "inline-grid" }}
                      ></i>
                    </div>
                    <div>Upload Another Banking</div>
                  </div>
                </div>

                {noOfBankErr != "" && (
                  <div className="bankErr">{noOfBankErr}</div>
                )}

                <div
                  className="cont-btn"
                  style={
                    files.length > 0
                      ? { backgroundColor: "#00B2A4", color: "#FFFFFF" }
                      : {}
                  }
                  onClick={handleNextClick}
                >
                  Next
                </div>
              </>
            )}

            <div className="bankPage">
              <div className="safety">
                <img src={safetyIcon} />
                <div id="safety-text">Your data is 100% safe & secure</div>
              </div>
            </div>
          </div>
        </div>
      </>
    </StateContext.Provider>
  );
}

const BankDropdown = () => {
  // List of banks

  const {
    isOpen,
    setIsOpen,
    searchTerm,
    setSearchTerm,
    selectedBank,
    setSelectedBank,
    dropdownRef,
  } = useContext(StateContext);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const filteredBanks = banks.filter((bank) =>
    bank.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectBank = (bank) => {
    setSelectedBank(bank);
    setSearchTerm(bank);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div className="input-container">
        {/* {!selectedBank && ( */}
        <span className="search-icon">
          <i className="bi bi-search"></i>
        </span>
        {/* )} */}
        <input
          type="text"
          placeholder="Search your bank"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onClick={toggleDropdown}
          className={`search-input ${selectedBank ? "with-selection" : ""}`}
        />
      </div>

      {isOpen && (
        <div className="dropdown">
          {filteredBanks.length > 0 ? (
            filteredBanks.map((bank, index) => (
              <div
                key={index}
                onClick={() => handleSelectBank(bank)}
                className="dropdown-item"
              >
                {bank}
              </div>
            ))
          ) : (
            <div className="no-banks">No banks found</div>
          )}
        </div>
      )}
    </div>
  );
};

const PointsToRemember = () => {
  const points = [
    {
      id: 1,
      text: "Current account or savings account should be in the name of the proprietor or the business.",
    },
    {
      id: 2,
      text: "Bank statement should be in a PDF format.",
    },
    {
      id: 3,
      text: "You can upload more than one file of the same account covering the full time period.",
    },
    {
      id: 4,
      text: "You can upload PDF files with a maximum size of 50MB.",
    },
  ];

  return (
    <div className="container" style={{ marginLeft: "10px" }}>
      <div style={{ color: "#1C1C1C", fontSize: "14px" }}>
        Points to remember:
      </div>

      <div>
        <div className="pointBoxes">
          <div className="pointText">
            <div className="pointerID">
                <img src={ptrem1} alt="pt1" style={{width:'30px',height:'auto'}}/>
            </div>
            Current account or savings account should be in the name of the
            proprietor or the business.
          </div>
          <div className="pointText" style={{ marginLeft: "auto" }}>
            <div className="pointerID">
            <img src={ptrem2} alt="pt2" style={{width:'30px',height:'auto'}}/>  
            </div>
            Bank statement should be in a PDF format.
          </div>
        </div>
        <div className="pointBoxes" >
          <div className="pointText">
            <div className="pointerID">
            <img src={ptrem3} alt="pt3" style={{width:'30px',height:'auto'}}/>
            </div>
            You can upload more than one file of the same account covering the
            full time period.
          </div>
          <div className="pointText" style={{ marginLeft: "auto" }}>
            <div className="pointerID">
            <img src={ptrem4} alt="pt1" style={{width:'30px',height:'auto'}}/>
            </div>
            You can upload PDF files with a maximum size of 50MB.
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankingComponent;
